// extracted by mini-css-extract-plugin
module.exports = {"loadingTemplate":"style_loadingTemplate__1LWbe","loading":"style_loading__1wmJM","empty":"style_empty__1blg2","image":"style_image__T2HL7","text":"style_text__czZII"};